import React from 'react';
import { Typography } from '@mui/material';
import { withStyles } from "tss-react/mui";
import classnames from 'classnames';
import styles from './styles';

const typographyBuilder = (variant, classNameFunc, coreProps = {}) => {
    // eslint-disable-next-line react/display-name
    return (props) => {
        const allProps = { ...coreProps, ...props };

        // call function to get the named class for this element
        const defaultClassName = classNameFunc(allProps.classes);

        // remove the classes, className and children properties before assigning the rest
        // to the element, otherwise material-ui will raise warnings that we are trying to
        // override properties that are not present on the element
        const { strong, classes, className, children, ...rest } = allProps;

        // merge the default class name with any additional ones provided
        const classNames = classnames(defaultClassName, className, strong ? classes.strong : '');

        return (
            <Typography variant={variant} className={classNames} {...rest}>
                {children}
            </Typography>
        );
    };
}

export const CenteredMessage = withStyles(typographyBuilder('h2', classes => classes.centeredMessage), styles);
export const Label = withStyles(typographyBuilder('body1', classes => classes.label), styles);
export const H1 = withStyles(typographyBuilder('h1', classes => classes.h1), styles);
export const H2 = withStyles(typographyBuilder('h2', classes => classes.h2), styles);
export const H3 = withStyles(typographyBuilder('h3', classes => classes.h3), styles);
export const H4 = withStyles(typographyBuilder('h4', classes => classes.h4), styles);
export const H5 = withStyles(typographyBuilder('h5', classes => classes.h5), styles);
export const H6 = withStyles(typographyBuilder('h6', classes => classes.h6), styles);
export const Subtitle1 = withStyles(typographyBuilder('subtitle1', classes => classes.subtitle1), styles);
export const Subtitle2 = withStyles(typographyBuilder('subtitle2', classes => classes.subtitle2), styles);
export const Body1 = withStyles(typographyBuilder('body1', classes => classes.body1), styles);
export const Body2 = withStyles(typographyBuilder('body2', classes => classes.body2), styles);
export const Button = withStyles(typographyBuilder('button', classes => classes.button), styles);
export const Caption = withStyles(typographyBuilder('caption', classes => classes.caption), styles);
export const Overline = withStyles(typographyBuilder('overline', classes => classes.overline), styles);
export const TextButton = withStyles(typographyBuilder('body1', classes => classes.textButton), styles);
